<!-- <div *ngIf="user"> -->

  <!-- sign up-->
  <div *ngIf="!isConfirm">
    <form onsubmit="return false;" [formGroup]="UserForm" (ngSubmit)="signUpithCognito()">
      <div class="container box">
        <label for="uname">
          <b>Name</b>
        </label>
        <input type="text" placeholder="Enter Username" name="uname" formControlName="name" [(ngModel)]="user.name"
          required />
        <!-- <div *ngIf="submitted && UserForm.controls.name.errors?.required">
              Name is required
            </div> -->

        <label for="uname">
          <b>Email</b>
        </label>
        <input type="email" placeholder="Enter Email" name="email" formControlName="email" [(ngModel)]="user.email"
          required />
        <!-- <div *ngIf="submitted && UserForm.controls.email.errors?.required">
              Email is required
            </div>
            <div *ngIf="submitted && UserForm.controls.email.errors?.email">
              Valid Email is required
            </div> -->

        <label for="uname">
          <b>Phone</b>
        </label>
        <input type="number" placeholder="Enter Phone" name="phone" formControlName="phone" [(ngModel)]="user.phone"
          required />

        <!-- <div *ngIf="submitted && UserForm.controls.phone.errors?.required">
              Mobile number is required
            </div>
      
            <div *ngIf="submitted &&  UserForm.controls.phone.errors?.pattern">
                Valid Mobile number is required
            </div> -->

        <label for="psw">
          <b>Password</b>
        </label>
        <input type="password" placeholder="Enter Password" name="pass" formControlName="pass" [(ngModel)]="user.pass"
          required />
        <!-- <div *ngIf="submitted && User.controls.pass.errors?.required">
              password number is required
            </div> -->

        <p>{{msg}}</p>
        <button type="submit">Creat Account</button>

      </div>
    </form>

  </div>

  <!-- confirm sign-up-->

  <div *ngIf="isConfirm">
      <!-- <form [formGroup]="UserForm" (ngSubmit)="onSubmit()">
        <div class="container box">
          <label for="uname">
            <b>Email</b>
          </label>
          <input type="email" placeholder="Enter Email" name="email" formControlName="email" [(ngModel)]="user.email"
            required />
          <span *ngIf="get_otp">
            <label for="psw">
              <b>Otp</b>
            </label>
            <input type="text" placeholder="Enter Otp" name="otp" 
              formControlName="otp" [(ngModel)]="user.otp"
            />
          </span>

          <p> {{msg}}</p>
          <button *ngIf="get_otp" type="button" (click)="confirmSignUp()">Submit</button>  
          <button *ngIf="!get_otp" type="submit">Submit</button>      
                           
        </div>
      </form> -->
  
   
  

    <div class="header">
      <h2>Enter Code</h2>
      <h4 style="color: green;">A verification code is sent to {{ user.email }}</h4>
    </div>

    <div class="form">
      <input type="text" name="otp" placeholder="Enter verification code" [(ngModel)]="user.otp">
      <button (click)="confirmSignUp()">CONFIRM</button>
      <p> {{msg}}</p>
    </div>
  </div>

<!-- </div> -->